/** 工具内部名 → 用户可见名（确认弹层等需要让用户知道将执行什么能力的场景） */
export const AGENT_TOOL_LABELS: Record<string, string> = {
  'comic.project.list': '浏览漫画项目',
  'comic.project.read': '读取漫画项目',
  'comic.episode.read': '读取话次详情',
  'comic.job.list_active': '查询进行中任务',
  'comic.job.read': '查询任务详情',
  'reference.gallery.folders': '浏览参考图库目录',
  'reference.gallery.list': '检索参考图库',
  'reference.gallery.save': '存入参考图库',
  'timeline.gallery.list': '获取时间线图库',
  'timeline.generate': '时间线生图',
  'comic.page.generate': '创建页级生图',
  'display_images': '展示图片',
  'ask_user': '模型提问',
}

export function agentToolLabel(toolName: string): string {
  const key = toolName.trim()
  return AGENT_TOOL_LABELS[key] ?? key
}

export function agentStatusLabel(status: string | undefined): string {
  switch ((status ?? '').trim()) {
    case 'running':
      return '进行中'
    case 'pending':
      return '待开始'
    case 'completed':
    case 'succeeded':
      return '已完成'
    case 'failed':
      return '失败'
    case 'cancelled':
      return '已取消'
    case 'awaiting_confirmation':
      return '等待确认'
    case 'tool_call':
      return '调用工具'
    case 'observation':
      return '观察结果'
    default:
      return status?.trim() || ''
  }
}

/** 主题语义色点：待确认用 warning；完成=绿，失败/取消=红 */
export function agentStatusDotClass(status?: string): string {
  switch ((status ?? '').trim()) {
    case 'running':
    case 'tool_call':
      return 'bg-[color-mix(in_srgb,var(--accent)_78%,white_8%)]'
    case 'awaiting_confirmation':
    case 'pending':
      return 'bg-[var(--color-warning)]'
    case 'completed':
    case 'succeeded':
    case 'done':
      return 'bg-[var(--color-success)]'
    case 'failed':
    case 'cancelled':
      return 'bg-[var(--color-error)]'
    default:
      return 'bg-[color-mix(in_srgb,var(--ink-soft)_40%,transparent)]'
  }
}
